var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "mb-2 mt-6",
              class: { "mt-n12": _vm.smAndDown },
              attrs: { cols: "12" },
            },
            [
              _c(
                "v-row",
                { staticClass: "px-0 py-0" },
                [
                  _c("v-col", { attrs: { cols: "auto" } }, [
                    _c("label", { staticClass: "section-heading" }, [
                      _vm._v("Service Information"),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("smart-calendar", {
                ref: "pickupRequest",
                attrs: {
                  minDate: _vm.pickupMinDate,
                  maxDate: _vm.pickupMaxDate,
                  disabled: false,
                  label: "Pickup Date",
                  required: true,
                },
                on: { change: _vm.pickupDateChanged },
                model: {
                  value: _vm.serviceInfo.pickupDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.serviceInfo, "pickupDate", $$v)
                  },
                  expression: "serviceInfo.pickupDate",
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("smart-calendar", {
                ref: "deliveryRequest",
                attrs: {
                  minDate: _vm.deliveryMinDate,
                  maxDate: _vm.deliveryMaxDate,
                  disabled: false,
                  required: true,
                  label: "Dropoff Date",
                },
                on: { change: _vm.deliveryDateChanged },
                model: {
                  value: _vm.serviceInfo.deliveryDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.serviceInfo, "deliveryDate", $$v)
                  },
                  expression: "serviceInfo.deliveryDate",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("smart-text-field", {
                attrs: { placeholder: "Declared Value", number: true },
                model: {
                  value: _vm.serviceInfo.declaredValue,
                  callback: function ($$v) {
                    _vm.$set(_vm.serviceInfo, "declaredValue", $$v)
                  },
                  expression: "serviceInfo.declaredValue",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showError
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-alert",
                    {
                      staticClass: "mt-2",
                      attrs: { color: "#f6123a", dense: "", outlined: "" },
                    },
                    [
                      _c(
                        "v-row",
                        { staticClass: "px-2", attrs: { align: "center" } },
                        [
                          _c(
                            "v-col",
                            { staticClass: "grow ta-l d-flex align-start" },
                            [
                              _c("img", {
                                staticClass: "mr-2",
                                staticStyle: { width: "24px" },
                                attrs: { src: _vm.ic_red_warning },
                              }),
                              _c("div", [
                                _c("label", { staticClass: "error-lbl" }, [
                                  _vm._v("Please fill in all required fields:"),
                                ]),
                                _c("div", { staticClass: "dark-text" }, [
                                  _c(
                                    "ul",
                                    { staticClass: "mt-2 mb-0 pl-4" },
                                    _vm._l(_vm.missingFields, function (field) {
                                      return _c("li", { key: field }, [
                                        _vm._v(" " + _vm._s(field) + " "),
                                      ])
                                    }),
                                    0
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }